import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Meta } from '@df/core/meta/meta';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { HideUpComponent } from '@df/ui/hide-up/hide-up.component';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { CMS_COMPONENT_MENU_CONFIG } from './cms-component-menu.config';
import { NCmsComponentMenu } from './cms-component-menu.interface';

@Component({
    selector: 'cms-component-menu',
    templateUrl: './cms-component-menu.component.html',
    standalone: true,
    imports: [CommonModule, HideUpComponent, HrefComponent, ICmsClientModule, ToggleModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsComponentMenuComponent>(CMS_COMPONENT_MENU_CONFIG)
export class CmsComponentMenuComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsComponentMenu.IData;

    meta = inject(Meta);

    isCurrent(path: string) {
        return path === this.meta.state?.url;
    }
}
